module.exports = __webpack_public_path__ + "static/noise-5058f6b59340f1f98757fdce96e77144.png";